import { render, staticRenderFns } from "./EventTeacherEditor.vue?vue&type=template&id=41007ac8"
import script from "./EventTeacherEditor.vue?vue&type=script&lang=js"
export * from "./EventTeacherEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports